import { jsx as _jsx } from "react/jsx-runtime";
import { Attachment } from '@dixa/lib-shared-habla';
import FileSaver from 'file-saver';
import { Component } from 'react';
import { connect } from 'react-redux';
import { ajaxSend } from '../../../../../api/api';
import { isPreviewableAttachment, prepareAttachments, } from '../../../../../app/utils/attachments';
import { actions } from '../../../../shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
const { attachmentsPreviewModalOpen } = actions;
const mapDispatchToProps = (dispatch) => {
    return {
        previewImage: (payload) => dispatch(attachmentsPreviewModalOpen(payload)),
    };
};
export const AttachedFile = connect(null, mapDispatchToProps)(class AttachedFile extends Component {
    constructor(props) {
        super(props);
        this.fetchPrivateFileBlob = (url) => {
            return ajaxSend({
                path: url,
                responseType: 'blob',
            });
        };
        this.fetchPrivateFile = (url) => {
            this.setState({ downloadAsyncStatus: 'loading' });
            this.fetchPrivateFileBlob(url)
                .then((blob) => {
                const url = this.props.fileUrl;
                FileSaver.saveAs(blob, this.props.prettyName
                    ? this.props.prettyName
                    : decodeURIComponent(url.split('/').pop()));
                this.setState({ downloadAsyncStatus: 'succeeded' });
            })
                .catch((e) => {
                console.error(e);
                this.setState({ downloadAsyncStatus: 'failed' });
            });
        };
        this.previewPrivateFile = (fileName, url) => {
            const { previewImage } = this.props;
            this.setState({ previewAsyncStatus: 'loading' });
            this.fetchPrivateFileBlob(url)
                .then((blob) => window.URL.createObjectURL(blob))
                .then((blobUrl) => {
                this.setState({ previewAsyncStatus: 'succeeded' });
                previewImage({ fileName, url: blobUrl });
            })
                .catch((e) => {
                console.error(e);
                this.setState({ previewAsyncStatus: 'failed' });
            });
        };
        this.state = {
            downloadAsyncStatus: 'succeeded',
            previewAsyncStatus: 'succeeded',
        };
    }
    render() {
        const { fileUrl, prettyName } = this.props;
        const fileName = prettyName
            ? encodeURIComponent(prettyName)
            : decodeURIComponent(fileUrl.split('/').pop());
        const onPreviewHandler = isPreviewableAttachment(fileName)
            ? () => this.previewPrivateFile(fileName, fileUrl)
            : null;
        return (_jsx(Attachment, { fileName: fileName, isDownloadLoading: this.state.downloadAsyncStatus === 'loading', isPreviewLoading: this.state.previewAsyncStatus === 'loading', onDownload: () => this.fetchPrivateFile(fileUrl), onPreview: onPreviewHandler
                ? () => (onPreviewHandler ? onPreviewHandler() : null)
                : undefined }));
    }
});
/**
 * Creates an array of `AttachedFile` components.
 *
 * @param attachedFiles The attached files.
 */
export function createAttachedFiles(attachedFiles) {
    return prepareAttachments(attachedFiles).map((file) => (_jsx(AttachedFile, { prettyName: file.name, fileUrl: file.absolute_uri }, file.absolute_uri)));
}
